/**
 * Extras exclude Filter, used for filtering extras for display and extra categories based on excluded rates
 */
bookingApp.filter('extrasExclude',['$filter',function(){
    var rateIsExcluded = function(rate, extra){

    };
    var extrasFilter = function(input, ratesInCart, roomRate){
        var out = [];
        angular.forEach(input, function(extra){
            // check if the extra has excluded rates - if not show
            if(typeof extra.excludedRates.length === 'undefined'){
                var rateWasFound = false;
                // loop through the rates
                for(var exRate in extra.excludedRates){
                    if(extra.excludedRates.hasOwnProperty(exRate)){

                        // loop through the rates

                                // check the chargeableTo level of the extra
                                switch(extra.chargeableTo){
                                    case 1: // room level
                                        if(typeof roomRate !== 'undefined'){
                                            if(parseInt(exRate) === parseInt(roomRate)){
                                                rateWasFound = true;
                                            }
                                        }
                                        break;
                                    case 2: // booking level
                                        if(typeof ratesInCart !== 'undefined'){
                                            if(ratesInCart.indexOf(parseInt(exRate)) >= 0){
                                                rateWasFound = true;
                                            }
                                        }
                                        break;
                                    case 3: // either level
                                        if(typeof roomRate !== 'undefined'){
                                            if(parseInt(exRate) === parseInt(roomRate)){
                                                rateWasFound = true;
                                            }
                                        } else {
                                            if(typeof ratesInCart !== 'undefined'){
                                                if(ratesInCart.indexOf(parseInt(exRate)) >= 0){
                                                    rateWasFound = true;
                                                }
                                            }
                                        }
                                        break;
                                }


                        // check the chargeableTo level of the extra
                        //switch(extra.chargeableTo){
                        //    case 1: // room
                        //        if(typeof roomRate !== 'undefined'){
                        //            if(parseInt(exRate) !== parseInt(roomRate)){
                        //                out.push(extra);
                        //            }
                        //        } else {
                        //            out.push(extra);
                        //        }
                        //        break;
                        //    case 2: // booking
                        //        if(typeof ratesInCart !== 'undefined'){
                        //            if(ratesInCart.indexOf(parseInt(exRate)) >= 0){
                        //            } else {
                        //                out.push(extra);
                        //            }
                        //        } else {
                        //            out.push(extra);
                        //        }
                        //        break;
                        //    case 3: // either
                        //        // check if the extra excluded is on the room
                        //        if(typeof roomRate !== 'undefined'){
                        //            if(parseInt(exRate) !== parseInt(roomRate)){
                        //                out.push(extra);
                        //            }
                        //        } else {
                        //            // check if the extra excluded rate is on one of the rooms in the cart already
                        //            if(typeof ratesInCart !== 'undefined'){
                        //                if(ratesInCart.indexOf(parseInt(exRate)) >= 0){
                        //                } else {
                        //                    out.push(extra);
                        //                }
                        //            } else {
                        //                out.push(extra);
                        //            }
                        //        }
                        //        break;
                        //}
                    }
                }
                if(!rateWasFound){
                    out.push(extra);
                }
            } else {
                out.push(extra);
            }
        });
        return out;
    };
    return extrasFilter;
}]);